import { atom } from "jotai";

export const hideAiSecretsFindingsAtom = atom<boolean>(false);
